import { defineMessage } from 'services/localization';

export const messages = {
    endStepBubbleTextNetSuite: defineMessage('approve_in_oracle_netsuite'),
    endStepDescriptionApproveInNetSuite: defineMessage('approved_pluraltemplate_oved_in_oracle_netsuite'),
};
